
import { useEffect, useState } from 'react';

export default function Loader() {
  const [currentPhrase, setCurrentPhrase] = useState(0);
  const [lineWidth, setLineWidth] = useState(0);

  const phrases = [
    'Finishing is the project.',
    'Precision. Restraint. Execution.',
    'Spaces are remembered by how they\'re finished.'
  ];

  useEffect(() => {
    const phraseTimer = setInterval(() => {
      setCurrentPhrase((prev) => (prev + 1) % phrases.length);
    }, 900);

    const lineTimer = setTimeout(() => {
      setLineWidth(200);
    }, 400);

    return () => {
      clearInterval(phraseTimer);
      clearTimeout(lineTimer);
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-[#F5F3EF] flex items-center justify-center z-50 px-4">
      <div className="text-center w-full max-w-3xl">
        <div className="h-16 md:h-20 flex items-center justify-center relative">
          {phrases.map((phrase, index) => (
            <p
              key={index}
              className={`absolute text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-serif text-[#2C2C2C] transition-opacity duration-700 px-4 w-full ${
                currentPhrase === index ? 'opacity-100' : 'opacity-0'
              }`}
            >
              {phrase}
            </p>
          ))}
        </div>
        <div className="flex justify-center mt-6 md:mt-8">
          <div
            className="h-[1px] bg-[#2C2C2C] transition-all duration-1000 ease-out"
            style={{ width: `${lineWidth}px` }}
          />
        </div>
      </div>
    </div>
  );
}
